import { getMessages } from '../../../../../store/constants';

export const SNACKBAR_UPGRADE_TEXT = getMessages().getText('snackbar.upgrade.text');
